export const Texture = name => PIXI.utils.TextureCache[name];

export const Sprite = name => new PIXI.Sprite(Texture(name));

export const Sound = name => sounds.get(`res/sounds/${name}`);

export const soundArray = (filenameTemplate, elementsCount, startFrom = 0) => {
    const array = [];
    for (let i = 0 ; i < elementsCount; i++) {
        array.push(Sound(filenameTemplate.$(i + startFrom)));
    }

    return array;
};

export const Tween = subject => new TWEEN.Tween(subject);



// WEBPACK FOOTER //
// ./src/gameutils.es6